
import { Check } from "@mui/icons-material";
import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from "@mui/material";
import { GuideTextBoxForPairedVerification, GuideTextBoxForStandAloneVerification } from "../../../Components/GuideTextBoxs";
import LoadingCircle from "../../../Components/LoadingCircleAnimated";
import { approvePayment, createPayment } from "../../../Data/Purchase/Payment";
import { verifyEmail, verifyOtp } from "../../../Data/User/Email";
import { useEffect, useRef, useState } from "react";

import { useToastAlert } from "design-system/Toast";
import { useSession, useSignIn } from "../../../Recoil/Session/Session";
import { useHistorys } from "../../../Recoil/Purchase/History";
import { logBehavior } from "../../../Data/Behavior";
import { useTitles } from "../../../Recoil/Novel/Title";
import { fn, validateEmailForm } from "../../../Functions";

const NudgeDialog = ({serviceId, titleId, menu}: {serviceId: string, titleId: string, menu?: string}) => {
    const {session, sessionRefresh} = useSession();
    const { titleObject, fetch, refreshTitle } = useTitles();

    const title = titleObject[`${serviceId}:${titleId}`] ?? {};


    const {toastAlert} = useToastAlert();
    const {EmailTokenSignin, EmailSignupWithOtp, EmailOnTemporalAccount} = useSignIn();
    const {history, refresh:refreshHistory} = useHistorys();

    useEffect(()=>{
        fetch([{serviceId, titleId}]);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [serviceId, titleId]);
        
    const [isNudgeVisible, setIsNudgeVisible] = useState(true);

    const [agreed, setAgreed] = useState(false);
    const [email, setEmail] = useState(session.email || '');
    const [otp, setOtp] = useState('');
    const [emailValidationStatus, setEmailValidationStatus] = useState<'success'|'fail'|'undone'>(session.email ? 'success' : 'undone');
    const [otpValidationStatus, setOtpValidationStatus] = useState<'success'|'fail'|'undone'>('undone');
    const [isVisibleOtpForm, setIsVisibleOtpForm] = useState(false);
    const [isEmailValidating, setIsEmailValidating] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
        
    
    const textBoxMontorTimer = useRef<ReturnType <typeof setTimeout>>(undefined);
    const isMenuSeen = useRef(false);
    let readCount = Object.keys({...localStorage}).filter(key => key.startsWith(`contents:${serviceId}:${titleId}`) ).length ;
    
    if (menu) {
        isMenuSeen.current = true;
    } else {
        if (!isMenuSeen.current) {
            fn.goto(`/payment/${serviceId}/${titleId}/menu`);
            return <></>;
        } else if (readCount <= title.freeEpisodeCount * 0.8 || title.timeRemain > 0 || history.find( h => h.serviceId === serviceId && h.titleId === titleId && h.status === '완료' )) {
            fn.goto(null);
        } else {
            logBehavior('purchase-viewNudge', {readCount});
        }    
    }

    if (history.find( h => h.serviceId === serviceId && h.titleId === titleId && h.status === '완료' )) {
        return <></>;
    }
    
    return <Dialog
        className={"NudgeDialog"}
        open={
            !menu && isMenuSeen.current
            && readCount > title.freeEpisodeCount * 0.8 && title.timeRemain === 0
            && isNudgeVisible
        }
        onClose={()=>{
            setIsNudgeVisible(false);
        }}
        hideBackdrop={false} disableScrollLock={true}
    >
        <DialogTitle className={"NudgeTitle"} >
            {`<${title.title}> 독자님!\n구매가 망설여지시나요?`}
        </DialogTitle>
        <DialogContent className={"NudgeContent"} >
            {`<${title.title}> 유료 분량을 살짝 감상해보세요.\n이메일을 통해 무료 15분 열람권을 보내드립니다.`}


            <GuideTextBoxForPairedVerification
                purpose={'send'}
                text={email}
                onChange={(event: any) => {
                    if (textBoxMontorTimer.current) {
                        clearTimeout(textBoxMontorTimer.current);
                    }
                    textBoxMontorTimer.current = setTimeout(() => {
                        logBehavior('purchase-trial-enter-email', {});
                    }, 300);
    
                    setEmail(event.target.value);
                }}
                placeholder={''}
                isDisabled={emailValidationStatus === 'success'}
                guideTexts={{ success: '인증되었어요.' }}
                validationStatus={emailValidationStatus}
                secondStepValidationStatus={otpValidationStatus}
                onClick={async () => {
                    if (!validateEmailForm(email)) {
                        logBehavior('purchase-invalid-email', {});
                        setEmailValidationStatus('fail');
                        return;
                    }
                    setIsEmailValidating(true);
    
                    const verifyEmailRes = await verifyEmail(email);
                    logBehavior('verify-email', {});
    
                    if (verifyEmailRes) {
                        setIsVisibleOtpForm(true);
    
                        logBehavior('verify-email(success)', {});
                    } else {
                        toastAlert('이메일에 문제가 있어요.', 3000, 'error');
                        logBehavior('verify-email(fail)', {});
                        setEmailValidationStatus('fail');
                    }
                    setIsEmailValidating(false);
                }}
            />

            { isVisibleOtpForm && <GuideTextBoxForStandAloneVerification
                purpose={'verification'}
                text={otp}
                onChange={(event : any) =>{ setOtp(event.target.value); }}
                placeholder={'코드가 전송됐어요. 이메일을 확인해주세요.'}
                guideTexts={{ fail: 'otp 인증에 실패했어요.' }}
                validationStatus={otpValidationStatus}
                onClick={async ()=>{
                    setIsEmailValidating(true);
                    const emailTokenSigninRes = await EmailTokenSignin(email, otp);
                    
                    if ( emailTokenSigninRes.email ) {
                        await sessionRefresh();
                        
                        logBehavior('email-token-login(success)', {});
                        setOtpValidationStatus('success');
                        setEmailValidationStatus('success');
                        setIsVisibleOtpForm(false);                                    
                    } else {
                        logBehavior('email-token-login(fail)', {});
                        
                        const verifyOtpRes = await verifyOtp(email, otp);
                        
                        if ( verifyOtpRes ) {
                            const name = email.split('@')[0];
                            const emailSignupRes = await EmailSignupWithOtp(email, otp, name);
    
                            if ( emailSignupRes ) {
                                await sessionRefresh();
    
                                logBehavior('email-signup-with-otp(success)', {});
                                setOtpValidationStatus('success');
                                setEmailValidationStatus('success');
                                setIsVisibleOtpForm(false);        
                            } else {
                                toastAlert('otp 인증에 실패했어요.', 3000, 'error');
                                logBehavior('email-signup-with-otp(fail)', {});
                                setEmailValidationStatus('undone');
                                setOtpValidationStatus('fail');                                
                            }
                        } else {
                            toastAlert('otp 인증에 실패했어요.', 3000, 'error');
                            logBehavior('verify-otp(fail)', {});
                            setEmailValidationStatus('undone');
                            setOtpValidationStatus('fail');                                
                        }
    
                    }
    
                    setIsEmailValidating(false);
                }}
            />}

            <div style={{display: 'flex', justifyContent: 'space-between', margin: '10px 0', color: 'rgb(117, 117, 117)', fontSize: '0.75rem'}}>
                <div 
                    style={{
                        display: 'flex', alignItems: 'center', cursor:'pointer',
                        color: `${agreed?'rgb(0,176,240)':''}`
                    }}
                    onClick={ (e) => {
                        setAgreed(!agreed);
                    }}
                >
                    <Check 
                        fontSize={'small'} 
                        style={{
                            marginRight: 15,
                        }} 
                    />
                    <div>
                        {`[필수] 이메일 정보 수집 및 이용에 동의합니다.`}
                    </div>
                </div>
            </div>
        </DialogContent>
        
        <DialogActions className={"NudgeActions"} >
            <Button fullWidth onClick={()=>{
                setIsNudgeVisible(false);
            }} >
                {"다음에 받을게요"}
            </Button>
            <Button
                fullWidth
                disableElevation
                disabled={!agreed || emailValidationStatus !== 'success' || !email}
                variant="contained"
                onClick={ async () => {
                    const productId = `${serviceId}:${titleId}:15min_free`;
                    const productInfo = {
                        finalAmount: 0,
                        detail: `15분동안 작품을 읽을 수 있습니다`,
                        name: '15분 무료 열람권'
                    };
                    if ( !productId || !productInfo ) {
                        toastAlert('결제 상품이 선택되지 않았습니다.', 5000, 'error');
                        return;
                    }
                    if (!session.email && sessionStorage.getItem('session:email')) {
                        let email = sessionStorage.getItem('session:email');
                        await EmailOnTemporalAccount(email);
                    }
    
                    logBehavior('purchase-tosspayment-start', {})
                    let popup = window.open(undefined, "팝업창", "width = 1000, height = 800, top = 50, left = 50, location = no");
                    if (popup?.document?.body){
                        popup.document.body.innerHTML = "열람권을 등록 중입니다..";
                    }
    
                    const orderId = (session.userid || "") + Math.round(new Date().getTime()/1000);
                    try {
                        const res = await createPayment({
                            method: '카드', amount: productInfo?.finalAmount, orderId, 
                            orderName: `${productInfo?.name}: ${productInfo.detail}`, 
                            orderDetail: [
                                {
                                    productId,
                                    quantity: 1, totalAmount: productInfo.finalAmount
                                }] });
                        
                        if (popup && res) {
                            popup.location.href = res;
                            const orderInformations  = {amount: productInfo.finalAmount, orderId};
    
                            let timer = setInterval(async () => {
                                if (popup?.closed) {
                                    logBehavior('purchase-popup-closed', {})
                                    clearInterval(timer);
    
                                    if ( !productInfo?.name ) {
                                        toastAlert('결제 상품이 선택되지 않았습니다.', 5000, 'error');
                                        return;
                                    }
    
                                    setIsLoading(true);
                                    try {
                                        const res = await approvePayment(orderInformations);
        
                                        if (res && res.orderId === orderInformations.orderId && res.amount === orderInformations.amount) {
                                            logBehavior('purchase-success-approve-tosspayment', {
                                                transaction_id: res.orderId,
                                                value: res.amount,
                                                currency: "KRW",
                                                items: [{
                                                    item_id: `${serviceId}:${titleId}`,
                                                    item_name: productInfo.name,
                                                    quantity: 1,
                                                }],
                                                pixel: 'Purchase'
                                            })
                                            setTimeout(()=>{
                                                setIsLoading(false);
                                                refreshTitle(Object.keys(titleObject).map( key => {
                                                    const [serviceId, titleId] = key.split(':');
                                                    return {serviceId, titleId};
                                                }));
                                                refreshHistory();
                                                setIsNudgeVisible(false);
                                                toastAlert('15분 무료 열람권이 발급되었습니다.', 5000, 'info');
                                                fn.goto(`/contents/${serviceId}/${titleId}`);
                                            },2000);
        
                                        } else {
                                            logBehavior('purchase-fail-approve-tosspayment', res)
                                            toastAlert('결제 인증에 실패했습니다.', 5000, 'error');
                                            setIsLoading(false);
                                        }
    
                                    } catch (e) {
                                        let logObject = res;
                                        if (typeof res === 'string'){
                                            logObject = {message: res};
                                        }
                                        logBehavior('purchase-fail-approve-tosspayment', logObject)
                                        toastAlert('결제 인증에 실패했습니다.', 5000, 'error');
                                        setIsLoading(false);
                                    }
                                
                                }
                            }, 10);
    
                        } else {
                            logBehavior('purchase-fail-tosspayment', res)
                            if(popup){
                                popup.close();
                            }   
                            toastAlert('결제에 실패했어요.', 5000, 'error');
                            // ChannelService.ChannelIO()('openChat');
                        }
                    }catch(e) {
                        console.error(e);
                        toastAlert('결제에 실패했어요.', 5000, 'error');
                        popup?.close();
                    }
                }}
            >
                {"무료 15분 열람권 받기"}
            </Button>
        </DialogActions>
        <LoadingCircle show={isEmailValidating || isLoading} />
    </Dialog>
};

export default NudgeDialog;